import { FC } from "react";

interface IssueResolutionViewProps {
  issue: {
    code: string;
    issueBackground: string;
    issueDetails: string;
    action: string;
    expectation: string;
    attachments: string[];
    classification: string;
    priority: string;
    clickupTicketId: string;
    resolutionDetails: string;
    createdBy: any;
    createdByType: string;
    meta: {
      ipAddress: string;
      userAgent: string;
      application: string;
    };
    status: string;
    stages: {
      user: string;
      userType: string;
      stage: string;
      notes?: string;
      escalatedTo?: string;
      timestamp: Date;
    }[];
    currentStage: {
      user: string;
      userType: string;
      stage: string;
      notes?: string;
      escalatedTo?: string;
      timestamp: Date;
    };
    createdAt: Date;
    updatedAt: Date;
  };
}

export const IssueResolutionView: FC<IssueResolutionViewProps> = ({
  issue,
}) => {

  return (
    <dl className="grid grid-cols-1 gap-x-4 gap-y-8 sm:grid-cols-3 p-6 overflow-y-auto">
      <div className="sm:col-span-3">
        <dt className="text-sm font-medium text-gray-500">Resolution Notes</dt>
        <dd className="mt-1 text-sm text-gray-900">
          {issue?.resolutionDetails || "N/A"}
        </dd>
      </div>
    </dl>
  );
};
